module.exports = __webpack_public_path__ + "static/img/26.a4bf21b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/26.png
// module id = cRj9
// module chunks = 1